import { parseSelectFilterOptions } from '../../util/search';
import { SPACE_TYPE_ALL_KEY } from '../../util/spaceTypes';

export const getFilterQueryParamName = filter => {
  const { queryParamNames } = filter || {};
  return Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
};

export const parseSelectedOptions = value => {
  return value ? parseSelectFilterOptions(value) : [];
};

export const formatMultiValue = (selectedOptions, searchMode) => {
  if (!selectedOptions.length) {
    return null;
  }

  return searchMode ? `${searchMode}:${selectedOptions.join(',')}` : selectedOptions.join(',');
};

export const parsePriceValue = value => {
  if (!value) {
    return null;
  }

  const [minValue, maxValue] = value.split(',').map(v => Number.parseInt(v, 10));
  return Number.isNaN(minValue) || Number.isNaN(maxValue)
    ? null
    : { minPrice: minValue, maxPrice: maxValue };
};

export const arePriceRangesEqual = (rangeA, rangeB) => {
  if (!rangeA || !rangeB) {
    return false;
  }

  return (
    rangeA.minPrice === rangeB.minPrice &&
    rangeA.maxPrice === rangeB.maxPrice &&
    rangeA.step === rangeB.step
  );
};

export const normalizePriceRange = (range, defaults) => {
  if (!defaults) {
    return range || null;
  }

  const minLimit = defaults.minPrice;
  const maxLimit = Math.max(defaults.maxPrice, minLimit + defaults.step);
  const sourceRange = range || defaults;
  const nextMin = Math.max(
    minLimit,
    Math.min(sourceRange.minPrice, maxLimit - defaults.step)
  );
  const nextMax = Math.min(maxLimit, Math.max(sourceRange.maxPrice, nextMin + defaults.step));

  return {
    minPrice: nextMin,
    maxPrice: nextMax,
    step: defaults.step,
  };
};

export const serializePriceRange = range => {
  return range ? `${range.minPrice},${range.maxPrice}` : null;
};

export const compactQueryParams = params => {
  return Object.entries(params || {}).reduce((acc, [key, value]) => {
    if (value === null || typeof value === 'undefined' || value === '') {
      return acc;
    }

    return { ...acc, [key]: value };
  }, {});
};

export const orderSpaceTypeOptions = options => {
  if (!Array.isArray(options)) {
    return [];
  }

  const allOption = options.find(option => option.key === SPACE_TYPE_ALL_KEY);
  const rest = options.filter(option => option.key !== SPACE_TYPE_ALL_KEY);
  return allOption ? [allOption, ...rest] : rest;
};
